export const getPage = () => {
	switch (window.location.pathname) {
		case '/':
			return 'main'
		case '/products/top_combinations':
			return 'top_combinations'
		case '/products/customer_groups':
			return 'customer_groups'
		case '/products/sales_forecasting':
			return 'sales_forecasting'
		case '/products/flow_of_customers':
			return 'flow_of_customers'
		case '/products/customer_forecast':
			return 'customer_forecast'
		case '/products/item_analytic':
			return 'item_analytic'
		case '/products/dinner_items':
			return 'dinner_items'
		default:
			return 'branch'
	}
}
